import React, { useState } from "react";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import { envelopIcon, deleteIcon } from "../../assets";
import Button from "../../component-lib/Molecules/button/Button";
import NotificationItem from "./NotificationItem";
import { useDispatch } from "react-redux";
import { getLoginUserId } from "../../utils/getToken";
import { clearAllNotification } from "../messaging-screen/messagingSaga";
import useSocketNotifications from "../../custom-hooks/UseSocketNotifications";

type Notification = {
  id: number;
  checkbox: boolean;
  name: string;
  notificationTitle: string;
  par: string;
  time: string;
};

const NotificationScreen = () => {
  const dispatch = useDispatch();
  const parseLoginUserId: any = getLoginUserId();
  const loginUserId = JSON.parse(parseLoginUserId);
  const { notifications, hasNew, setHasNew, clearNotifications } =
    useSocketNotifications(loginUserId);

  // const [notificationData, setNotificationData] = useState(notifications);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState<Notification[]>(
    []
  );

  // Extract name after "by"
  const extractName = (str: string) => {
    const match = str.match(/by\s([A-Za-z]+\s[A-Za-z]+)/);
    return match ? match[1] : "";
  };

  const obj: Notification[] = notifications?.map((data: any) => ({
    id: data?.id, // Add a unique ID for each notification
    checkbox: false,
    name:
      data?.sender?.firstName && data?.sender?.lastName
        ? data?.sender?.firstName + " " + data?.sender?.lastName
        : extractName(data?.description),
    notificationTitle: data?.title,
    par: data?.description,
    time: data?.createdAt,
    status: data?.order?.status,
    orderId: data?.orderId,
  }));

  const handleCheckboxChange = (data: Notification) => {
    // setNotificationData((prevData: any) => {
    //   return prevData.map((item: any) =>
    //     item.id === data.id
    //       ? { ...item, checkbox: !item.checkbox } // toggle the `isRead` property or modify as needed
    //       : item
    //   );
    // });
    // setSelectedCheckboxes((prev) =>
    //   prev.some((selectedItem) => selectedItem.id === item.id)
    //     ? prev.filter((selectedItem) => selectedItem.id !== item.id)
    //     : [...prev, item]
    // );
  };
  const handleClearAll = () => {
    // setSelectedCheckboxes([]);
  };

  const groupNotificationsByDate = (notificationData: any) => {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const formatDate = (
      date: Date | string | null | undefined
    ): string | null => {
      if (!date) return null;

      const parsedDate = date instanceof Date ? date : new Date(date);
      if (isNaN(parsedDate.getTime())) return null; // Handle invalid dates

      return parsedDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD
    };
    const todayStr = formatDate(today);
    const yesterdayStr = formatDate(yesterday);

    return notificationData?.reduce(
      (acc: any, notification: any) => {
        const notifDateStr = formatDate(new Date(notification.time));

        if (notifDateStr === todayStr) {
          acc.today.push(notification);
        } else if (notifDateStr === yesterdayStr) {
          acc.yesterday.push(notification);
        } else {
          acc.previous.push(notification);
        }
        return acc;
      },
      { today: [], yesterday: [], previous: [] }
    );
  };

  const groupedNotifications = groupNotificationsByDate(obj);

  return (
    <WrapperCard customClasses="m-3 p-3 flex-1 min-h-0 overflow-hidden">
      <div className="space-y-4 pb-4">
        <div className="flex justify-between items-center">
          <h2 className="text-[#1D1D1D] text-[18px] font-semibold h-10">
            Notifications
          </h2>
          {notifications?.length >= 1 && (
            <Button
              type="submit"
              label="Clear all"
              variant="contained"
              onClickCb={() => {
                const payload = {
                  loginUserId: loginUserId,
                  clearNotifications,
                };
                dispatch(clearAllNotification(payload));
              }}
              style={{
                background: "#E4F3FF",
                color: "#005596",
                width: "88px",
                height: "36px",
                padding: "8px 14px",
                fontSize: "14px",
              }}
            ></Button>
          )}
        </div>
      </div>
      <div className="space-y-4 pb-4 pr-[3px] overflow-auto h-[93%]">
        {selectedCheckboxes.length > 0 && (
          <div className="flex justify-between items-center h-5 mt-[3px]">
            <div className="flex gap-2 items-center cursor-pointer">
              <img
                src={envelopIcon}
                alt="envelopIcon"
                className="w-[20px] h-[20px]"
              />
              |
              <img
                src={deleteIcon}
                alt="deleteIcon"
                className="w-[20px] h-[20px]"
                onClick={handleClearAll}
              />
            </div>
          </div>
        )}
        {notifications?.length >= 1 ? (
          <div>
            {groupedNotifications.today.length > 0 && (
              <h3 className="text[#BCBCBC] text-[16px] font-semibold mb-2">
                Today
              </h3>
            )}

            {groupedNotifications.today.map((data: any, index: number) => (
              <NotificationItem
                key={index}
                data={data}
                handleCheckboxChange={(data: any) => {
                  handleCheckboxChange(data);
                }}
              />
            ))}

            {groupedNotifications.yesterday.length > 0 && (
              <h3 className="text[#BCBCBC] text-[16px] font-semibold mb-2">
                Yesterday
              </h3>
            )}
            {groupedNotifications.yesterday.map((data: any, index: number) => (
              <NotificationItem
                key={index}
                data={data}
                handleCheckboxChange={(data: any) => {
                  handleCheckboxChange(data);
                }}
              />
            ))}

            {groupedNotifications.previous.length > 0 && (
              <h3 className="text[#BCBCBC] text-[16px] font-semibold mb-2">
                Previous
              </h3>
            )}

            {groupedNotifications.previous.map((data: any, index: any) => (
              <NotificationItem
                key={index}
                data={data}
                handleCheckboxChange={(data: any) => {
                  handleCheckboxChange(data);
                }}
              />
            ))}
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>No New Notification</div>
        )}
      </div>
    </WrapperCard>
  );
};

export default NotificationScreen;
